//
export const ALL_STATE_LIST = 'ALL_STATE_LIST'
export const ALL_STATE_LIST_SUCCESS = 'ALL_STATE_LIST_SUCCESS'
export const STATE_LIST_RESET = 'STATE_LIST_RESET'